import React from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "../../routes/constants";
import { hasPermission } from "../../utils/helper";
import { PERMISSION } from "../../utils/constants";
import courierMark from "../../images/bike-busy.svg";

const TABS = [
  {
    label: "Couriers",
    route: ROUTES.COURIERS,
    match: "couriers",
    icon: courierMark
  },
  { label: "Zones", route: ROUTES.COURIER_ZONES, match: "zones" },
  { label: "Centers", route: ROUTES.COURIER_CENTERS, match: "centers" },
  { label: "Rounds", route: ROUTES.COURIER_ROUNDS, match: "rounds" },
  { label: "Schedules", route: ROUTES.COURIER_SCHEDULES, match: "schedules" },
  { label: "Shifts", route: ROUTES.COURIER_SHIFTS, match: "shifts" },
  { label: "Trips", route: ROUTES.COURIER_TRIPS, match: "trips" },
  { label: "My Workflow", route: ROUTES.COURIER_WORKFLOW, match: "workflow" },
  { label: "Live Monitor", route: ROUTES.COURIER_MONITOR, match: "monitor" },
  { label: "Reports", route: ROUTES.COURIER_REPORTS, match: "reports" }
];

const CourierTabs = () => {
  if (!hasPermission(PERMISSION.CAN_VIEW_COURIER)) return null;
  const pathName = window.location.pathname;
  return (
    <ul className="assign-filter-head courier-tabs">
      {TABS.map(tab => (
        <li
          key={tab.route}
          className={pathName.includes(tab.match) ? "active" : ""}
        >
          <Link to={tab.route}>
            {tab.icon && (
              <img src={tab.icon} alt="" className="courier-tab-icon" />
            )}
            {tab.label}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default CourierTabs;
